import { render, staticRenderFns } from "./pcLoginComponent.vue?vue&type=template&id=a4e577fc&scoped=true"
import script from "./pcLoginComponent.vue?vue&type=script&lang=js"
export * from "./pcLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./pcLoginComponent.vue?vue&type=style&index=0&id=a4e577fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e577fc",
  null
  
)

export default component.exports